import { AppDispatch } from '@Store';
import { postFedExDetails } from '@Reducers/AdminShipment/actions';
import dayjs from 'dayjs';
import { BluedartInformation } from './BlueDartInformation';
import { DropdownOptionType } from '@Components/Dropdown/Type';

export enum ProductTypeEnum {
  PPX = 'PPX',
  DPX = 'DPX',
  GPX = 'GPX',
}

export enum PaymentTypeEnum {
  P = 'P',
  C = 'C',
  D = 'D',
  A = 'A',
  B = 'B',
}

export const onForward = ({
  values,
  shipmentNumber,
  dispatch,
  nextFunc,
}: {
  values: BluedartInformation;
  shipmentNumber: string;
  dispatch: AppDispatch;
  nextFunc: () => void;
}) => {
  const body = { ...JSON.parse(JSON.stringify(values)) };
  const { accountNo } = body;
  body.csp = 'bluedart';
  body.accountNo = accountNo?.[0]?.value;

  if (Array.isArray(body.subProductCode)) {
    body.subProductCode = body.subProductCode[0]; // or `.join(',')` if multiple values are needed as comma-separated
  }

  for (const key in body) {
    if (body[key]) {
      if (key === 'accountNo') {
        body[key] = body[key]?.split('-')?.[0];
      }
      if (key === 'invoiceDate') {
        body[key] = dayjs(values?.invoiceDate).format('MM/DD/YYYY');
      }
    }
  }

  dispatch(
    postFedExDetails({
      shipmentNumber: `${shipmentNumber}`,
      body,
      date: values?.invoiceDate ? dayjs(values?.invoiceDate).format() : '',
      nextFunc,
    }),
  );
};

export const ProductTypeOptions: DropdownOptionType[] = [
  { value: ProductTypeEnum.PPX, display: 'PPX' },
  { value: ProductTypeEnum.DPX, display: 'DPX' },
  { value: ProductTypeEnum.GPX, display: 'GPX' },
];

export const PaymentTypeOptions: DropdownOptionType[] = [
  { value: PaymentTypeEnum.P, display: 'Prepaid' },
  { value: PaymentTypeEnum.C, display: 'Cash on Delivery' },
  { value: PaymentTypeEnum.A, display: 'FOD i.e. Freight on Delivery' },
  { value: PaymentTypeEnum.B, display: 'DOD FOD' },
  { value: PaymentTypeEnum.D, display: 'DOD i.e. Demand Draft on Delivery' },
];
